import * as profileReducer from '../reducers/profile';

export const showProfileSidePanel = () => dispatch => {
    dispatch(profileReducer.OPEN_PROFILE_SIDE_PANEL());
};

export const closeProfileSidePanel = () => dispatch => {
    dispatch(profileReducer.CLOSE_PROFILE_SIDE_PANEL());
};

export const setCurrentTab = (tab) => dispatch => {
    dispatch(profileReducer.SET_CURRENT_TAB(tab));
};

export const setCurrentRegulationType = (tab) => dispatch => {
    dispatch(profileReducer.SET_CURRENT_REGULATION_TYPE(tab));
};



  /* -------------------------------------------------------------------------- */
  /*                         Manage Subscription                                */
  /* -------------------------------------------------------------------------- */
export const setSubscriptionPlans = (plans, period) => dispatch => {
    dispatch(profileReducer.SET_SUBSCRIPTION_PLANS({plans, period}));
};


export const showSubscriptionCards = (type, show) => dispatch => {
    dispatch(profileReducer.SHOW_SUBSCRIPTION_CARDS({type, show}));
};

export const setCurrentUserPlan = (type) => dispatch => {
    dispatch(profileReducer.SET_USER_PLAN({type}));
};

export const setCurrentUser = (user) => dispatch => {
    dispatch(profileReducer.SET_USER(user));
};